import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom"; // Use Navigate to redirect
import { auth } from "../firebase"; // Firebase Auth
import { onAuthStateChanged } from "firebase/auth"; // Firebase method to track auth state

const PrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true); // Track loading state
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true); // User is authenticated
      } else {
        setIsAuthenticated(false); // User is not authenticated
      }
      setLoading(false); // Stop loading after checking the auth state
    });

    return () => unsubscribe(); // Clean up listener on component unmount
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Optionally, display a loading state while checking authentication
  }

  return isAuthenticated ? children : <Navigate to="/login" />; // Redirect to login if not authenticated
};

export default PrivateRoute;  // Ensure it's default export
